import { ax } from '@src/utils/axios/axios'
import { BASE_API_URL } from '@src/constants'

interface Options {
  monthOffset?: number
  depotId?: string
  stateId?: string
}

export interface ShiftCostItem {
  project_id: string
  project_name: string
  depot_id: string
  depot_name: string
  shift_id: number
  shift_date: string
  drs_summary_id: number
  project_revenue: number | null
  comments: string | null
  labour_cost: number
  material_cost: number
  subcontractor_cost: number
  mobile_asset_cost: number
  project_cost_items: number
  overhead_cost: number
  total_cost: number
  total_tonnes: number
  total_binder: number
}

export interface ShiftCostSummary {
  totalShifts: number
  totalProjectRevenue: number
  totalLabourCost: number
  totalMaterialCost: number
  totalSubcontractorCost: number
  totalProjectCostItems: number
  grandTotalCost: number
  totalTonnes: number
  totalBinder: number
}

export interface ProjectShiftCostsResponse {
  shifts: ShiftCostItem[]
  summary: ShiftCostSummary
}

export const apiProjectShiftCosts = ({ monthOffset, depotId, stateId }: Options = {}) => {
  const params: any = {}

  if (monthOffset !== undefined) params.monthOffset = monthOffset
  if (depotId) params.depotId = depotId
  if (stateId) params.stateId = stateId

  return ax({
    method: 'GET',
    url: `${BASE_API_URL}/v2/reports/project-shift-costs`,
    params,
  })
}
